import { render, staticRenderFns } from "./contactCategories.vue?vue&type=template&id=2b348f94&scoped=true"
import script from "./contactCategories.vue?vue&type=script&lang=js"
export * from "./contactCategories.vue?vue&type=script&lang=js"
import style0 from "./contactCategories.vue?vue&type=style&index=0&id=2b348f94&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b348f94",
  null
  
)

export default component.exports